import axiosInstance from '@/api/axiosInstance';
import { adoptSignInTenant, tokenStorage } from '@/api/tokenManager';
import { AUTH_ENDPOINTS } from '@/api/endpoints/auth.endpoints';
import { LoginRequest, TokenResponse, RegisterUserRequest } from '@/types/authentication.types';

export const AuthApi = {
  login: async (credentials: LoginRequest): Promise<TokenResponse> => {
    const response = await axiosInstance.post<TokenResponse>(AUTH_ENDPOINTS.LOGIN, credentials);
    if (response.data.access_token) {
      tokenStorage.setTokens(response.data.access_token, response.data.refresh_token);
      adoptSignInTenant(response.data.access_token);
    }
    return response.data;
  },
  refreshToken: async (): Promise<TokenResponse> => {
    const currentRefreshToken = tokenStorage.getRefreshToken();
    if (!currentRefreshToken) throw new Error('No refresh token available for explicit refresh');
    const response = await axiosInstance.post<TokenResponse>(AUTH_ENDPOINTS.REFRESH_TOKEN, { refresh_token: currentRefreshToken });
    if (response.data.access_token) {
      tokenStorage.setTokens(response.data.access_token, response.data.refresh_token);
    }
    return response.data;
  },
  register: async (userData: RegisterUserRequest): Promise<string> => {
    const response = await axiosInstance.post<{ message: string } | string>(AUTH_ENDPOINTS.REGISTER, userData);
    return typeof response.data === 'string' ? response.data : (response.data as { message: string }).message;
  },
  checkAuth: (): boolean => !!tokenStorage.getAccessToken(),
  logout: (): void => {
    // UAT DEF-010: end the session server-side as well; keepalive lets the request outlive the redirect.
    const token = tokenStorage.getAccessToken();
    if (token) {
      fetch(AUTH_ENDPOINTS.LOGOUT, {
        method: 'POST',
        keepalive: true,
        headers: { Authorization: `Bearer ${token}`, 'X-Tenant-ID': localStorage.getItem('tenant_id') || '1' },
      }).catch(() => {});
    }
    tokenStorage.clearTokens();
    window.location.href = '/login';
  },
};